
import XHeader from 'vux/src/components/x-header/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'


export default {
props: ['memberId'],
components: {
XHeader,
Group,
Cell,
XButton
},
data() {
return {
member: {info: {}, self: {}},
pageLoaded: false,
}
},
computed: {
userLevel() {
let al = this.member.info.agent_level;
let isAgent = this.member.info.is_agent;
let ul = this.member.info.level;

if (isAgent > 0) {
switch (al) {
case 6:
return '区县经销商';
case 3:
return '区县代';
case 2:
return '市级代理';
case 1:
return '省级代理';
}
} else {
switch (ul) {
case 4:
return '高级用户';
case 3:
return '中级用户';
case 2:
return '初级用户';
case 1:
return '普通用户';
}
}
}
},

created: function () {
document.title = this.memberId + '的个人信息';
this.$vux.loading.show({
'text': '加载中'
});
const url = this.tianYiWebUrl + '/wechat/uc/ajaxGetMemberInfo';
this.$http.get(url, {params: {uid: this.memberId}}).then(r => {
let res = r.data;
if (res.code === 200) {
this.member = res.data;
console.log(this.member)
this.pageLoaded = true;
this.$vux.loading.hide();
}
})
}
}



// WEBPACK FOOTER //
// ./src/components/uc/MemberInfo.vue